import React, { useContext, useEffect, useState } from 'react'

// Components
import PageWrapper from 'components/PageWrapper'
import { MeContext } from 'contexts/me'
import { getCard, getUrlActivationPhysicalCard } from 'api/credit-card'
import { WomanInMoshion } from 'assets/icons'
import { trackEvent } from 'analytics/trackFunctions'

const ActivatePhysicalCard = () => {
  const { me } = useContext(MeContext)
  const [, setLoading] = useState()
  const [cardActivationUrl, setCardActivationUrl] = useState(null)

  async function getData() {
    setLoading(true)
    getCard({ data: me?.user?.uuid, type: 'PHYSICAL' })
      .then((res) => getUrlActivationPhysicalCard(res.data.uuid))
      .then((res) => {
        setCardActivationUrl(res)
      })
  }

  useEffect(() => {
    getData()
    trackEvent({ eventName: 'bille_pantalla_activar_tarjeta_fisica' })
  }, [])

  return (
    <PageWrapper noTabBar viewSelected='/mis-tarjetas' title='Tarjeta Wayni'>
      <section className='md:max-w-564 md:flex md:items-start md:flex-col mx-auto flex flex-col md:text-center'>
        {cardActivationUrl && (
          <>
            <div className='p-8 w-full justify-center'>
              <span className='w-full text-left text-xs font-bold text-purple-900'>
                En Wayni nunca vamos a solicitar <br /> tus datos personales y/o
                números de tarjeta.
              </span>
            </div>
            <div className='flex w-full justify-center items-center'>
              <WomanInMoshion />
            </div>
            <div className='w-full h-80'>
              <iframe
                title='Formulario de activación'
                src={cardActivationUrl}
                scrolling='off'
                frameborder='0'
                Style='overflow:hidden;height:100%;width:100%'
                height='100%'
                width='100%'
              />
            </div>
            <div className='px-8'>
              <ul className='w-full text-left text-2xs font-bold text-purple-900 list-disc'>
                <li>Debe ser de 4 dígitos</li>
                <li>No debe ser una secuencia ascendente. Por ejemplo 123</li>
                <li>No debe ser una descendente. Por ejemplo 4321</li>
                <li>No debe ser una repetición de números. Por ejemplo 1111</li>
              </ul>
            </div>
          </>
        )}
      </section>
    </PageWrapper>
  )
}

export default ActivatePhysicalCard
